<!-- Modal Container -->
<div [class.fixed]="!embedded"
     [class.inset-0]="!embedded"
     [class.z-50]="!embedded"
     [class.flex]="!embedded"
     [class.items-center]="!embedded"
     [class.justify-center]="!embedded"
     [class.p-4]="!embedded"
     role="dialog"
     aria-modal="true"
     aria-labelledby="payment-modal-title"
     aria-describedby="payment-modal-description">
  <!-- Modal Content -->
  <div class="relative bg-white rounded-lg flex flex-col z-10 w-full"
       [class.shadow-2xl]="!embedded"
       [class.max-w-md]="!embedded"
       role="document"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="flex justify-between items-center p-6 border-b border-gray-200" *ngIf="!embedded">
      <h2 id="payment-modal-title" class="text-xl font-semibold text-gray-900" i18n>Avtorizacija plačila</h2>
      <button type="button"
              (click)="onCancel()"
              [disabled]="processing"
              aria-label="Close modal"
              class="text-gray-500 hover:text-gray-900 transition-colors p-2 disabled:opacity-50">
        <span class="material-icons text-2xl" aria-hidden="true">close</span>
      </button>
    </div>

    <!-- Body -->
    <div class="w-full"
         [class.p-6]="!embedded">
      <!-- Instructions -->
      <div id="payment-modal-description" class="mb-6 p-4 bg-blue-50 border border-blue-200 rounded flex items-start gap-3">
        <i class="fas fa-info-circle" aria-hidden="true"></i>
        <p class="text-sm text-blue-900" i18n>
          Vaša kartica bo avtorizirana za samodejno plačevanje. Zdaj ne bo zaračunano.
        </p>
      </div>

      <!-- Card Number -->
      <div class="mb-4">
        <label for="card-number-element" class="block text-sm font-medium text-gray-700 mb-2" i18n>
          Številka kartice
        </label>
        <div class="relative w-full">
          <div *ngIf="loading"
               class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10 rounded"
               role="status"
               aria-label="Loading payment form">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
          <div #cardNumber
               id="card-number-element"
               class="p-3 border border-gray-300 rounded bg-white min-h-[44px] w-full"
               aria-label="Card number input"></div>
        </div>
      </div>

      <!-- Expiry + CVC Row -->
      <div class="grid grid-cols-2 gap-4 mb-4">

        <!-- Expiry -->
        <div>
          <label for="card-expiry-element" class="block text-sm font-medium text-gray-700 mb-2" i18n>
            Veljavnost
          </label>
          <div #cardExpiry
               id="card-expiry-element"
               class="p-3 border border-gray-300 rounded bg-white min-h-[44px] w-full"
               aria-label="Card expiry date input"></div>
        </div>

        <!-- CVC -->
        <div>
          <label for="card-cvc-element" class="block text-sm font-medium text-gray-700 mb-2" i18n>
            CVC
          </label>
          <div #cardCvc
               id="card-cvc-element"
               class="p-3 border border-gray-300 rounded bg-white min-h-[44px] w-full"
               aria-label="Card CVC input"></div>
        </div>
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage"
           class="mb-4 p-4 bg-red-50 border border-red-200 rounded flex items-start gap-3"
           role="alert"
           aria-live="polite">
        <i class="fas fa-exclamation-circle text-red-600" aria-hidden="true"></i>
        <p class="text-sm text-red-900">{{ errorMessage }}</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-end gap-3 w-full"
         [class.p-6]="!embedded"
         [class.border-t]="!embedded"
         [class.border-gray-200]="!embedded"
         [class.mt-4]="embedded">
      <button type="button"
              (click)="onCancel()"
              [disabled]="processing"
              class="btn btn-grayDark-link mx-2">
        <span i18n>Prekliči</span>
      </button>

      <button type="button"
              (click)="onSubmit()"
              [disabled]="loading || processing || configurationError"
              [attr.aria-busy]="processing"
              class="btn btn-sm btn-primary w-full md:w-auto">
        <span *ngIf="!processing" i18n>Avtoriziraj plačilo</span>
        <span *ngIf="processing" class="flex items-center gap-2">
          <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
          <span i18n>Obdelava...</span>
        </span>
      </button>
    </div>
  </div>

  <!-- Backdrop -->
  <div *ngIf="!embedded"
       class="fixed inset-0 bg-black bg-opacity-50 -z-10"
       (click)="!processing && onCancel()"
       aria-hidden="true">
  </div>
</div>
